import { z } from 'zod'

export const loadContext = z.object(
  {
    LOCALE: z.union([z.literal('en-US'), z.literal('en-GB')]),
    DEPLOY_ENV: z.union([
      z.literal('development'),
      z.literal('qa'),
      z.literal('stg'),
      z.literal('prd')
    ]),
    GTM_ID: z.string()
  },
  {
    errorMap: _ => ({
      message:
        'Missing loader context. This means this function is not being run on the Express server and you need to mock out `context`.'
    })
  }
)
